import styled from 'styled-components'
import { getFontStyle } from '@diversioteam/diversio-ds'

import { ChipsListItem as CatalogChipsListItem } from 'components/Catalog/CatalogItem/catalogItem.styles'
import templateImage from 'assets/images/pulseSurveys/template.png'

export const TemplateItemWrapper = styled.li`
    display: grid;
    grid-template-areas:
        'title thumbnail'
        'description thumbnail'
        'chips thumbnail';
    grid-template-columns: 1fr auto;
    grid-template-rows: min-content min-content 1fr;
    grid-gap: 8px 24px;
    min-height: 168px;
    min-width: 340px;
    padding: 24px;
    border-radius: 16px;
    background-color: ${({ theme }) => theme.colors.primaryWhite};
    border: 1px solid ${({ theme }) => theme.colors.primaryGray2};
    cursor: pointer;
    padding: 24px;
    transition: transform 0.1s cubic-bezier(0.075, 0.82, 0.165, 1);

    &:hover {
        transform: scale(1.02);
    }
`

export const Title = styled.h3`
    grid-area: title;
    color: ${({ theme }) => theme.colors.primary90};

    ${getFontStyle('p01Semibold')}
`

export const Description = styled.p`
    margin: 0;
    grid-area: description;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    color: ${({ theme }) => theme.colors.secondary500};

    ${getFontStyle('p02Regular')}
`

export const Thumbnail = styled.div<{ categoryKey?: string }>`
    grid-area: thumbnail;
    height: 120px;
    width: 120px;
    flex-shrink: 0;
    border-radius: 12px;
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.primary10};
    background-image: url(${templateImage});
    background-size: cover;
    background-position: 50% 50%;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`

export const ChipsListItem = styled(CatalogChipsListItem)`
    grid-area: chips;
    align-self: flex-end;
`
